module.exports = __webpack_public_path__ + "favicon/android-chrome-384x384.png";